import { has, escape } from 'lodash-es';

import { AxiosError } from 'axios';

const isString = (e: Error | string): e is string => typeof e === 'string';

const isAxiosError = (e: Error | AxiosError): e is AxiosError => has(e, 'isAxiosError')
const hasAxiosResponse = (e: AxiosError) => !!e.response
const hasAxiosRequest = (e: AxiosError) => !!e.request

const hasStackTrace = (e: Error) => has(e, 'stack')

type AnnotatedError = { e: Error | string, humanMessage: string };

export class UploadErrors {
    // doesnt actually need to be dynamically generated - just something to prevent
    // collisions with anybody else's ids / data-targets
    private uuid = '2eb3b262-2e2a-48a1-836b-c02561b8d377';

    errors: Array<AnnotatedError> = [];

    constructor() { }

    addError(humanMessage: string, error: Error) {
        this.errors.push({
            e: error,
            humanMessage,
        });

        this.rerender();
    }

    clearErrors() {
        this.errors = [];

        this.rerender();
    }

    rerender() {
        let html = '';
        if (this.errors.length > 0) {

            html = `
<div class="alert alert-danger" >
  <div>
    <a class="expand-btn collapsed" data-toggle="collapse" data-target="#upload-error_data_${this.uuid}" type="button" href="" aria-expanded="false">
      <span class="if-not-collapsed fas fa-angle-double-down"></span>
      <span class="if-collapsed fas fa-angle-double-right"></span>
An error occurred during uploading. Expand for details.
    </a>
  </div>
  <div id="upload-error_data_${this.uuid}" class="collapse">
Browser user agent: ${navigator.userAgent}<br><br>
--<br><br>
${this.errors.map(e => this.wrappedDetails(e)).join('---<br><br>')}
  </div>
</div>
`;
        }
        $('#uppy-errors-hole').html(html);
    }

    wrappedDetails(error: AnnotatedError) {
        return `<pre>${this.getDetails(error)}</pre>`;
    }

    getDetails(annotated: AnnotatedError): string {
        const error = annotated.e;
        let errorText = `Section: ${annotated.humanMessage}
`;

        if (isString(error)) {
            errorText += `ERROR: ${error}`;
            return errorText;
        }

        errorText += `ERROR: ${error.message}
`;

        if (hasStackTrace(error)) {
            errorText += `
Error stack:
${error.stack}
`;
        }

        if (isAxiosError(error)) {
            errorText += `
Axios Config: ${ JSON.stringify(error.config)}
`;

            // note: this is an XMLHttpRequest - an object that has no nice toString and jsonifys to {} ...
            //             if (hasAxiosRequest(this.error)) {
            //                 errorText += `
            // Axios Request: ${JSON.stringify(this.error.request)}
            // `;
            //        }

            if (hasAxiosResponse(error)) {
                errorText += `
Axios Response:
   http code: ${error.response?.status}
   headers: ${JSON.stringify(error.response?.headers)}
   data: ${error.response?.data}
`;
            }

            errorText += `
Axios message: ${error.message}
`;
        }

        return escape(errorText);
    }
}
